/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {RoleListPageComponent} from './role-list-page.component';

@Component({
  standalone: true,
  imports: [RoleListPageComponent],
  selector: 'adn-role-route-page',
  template: `
    <adn-role-list-page
      [readOnly]="readOnly">
    </adn-role-list-page>
  `
})
export class RoleRoutePageComponent {
  @Input() readOnly = false;
}
